export default __webpack_public_path__ + "static/media/p2p-img.420358dc.webp";